export const imageObj = [
    {
      ServicesH2: "Studies",
      Icon: require("../../images/school.svg").default,
      ServicesP: "view",
      ServicesP2: ``,
      imgStart:true,
      alt:'Studies',
      content:'studies'
    },
    {
      ServicesH2: "Work",
      Icon: require("../../images/work2.svg").default ,
      ServicesP: "view",
      ServicesP2: ``,
      imgStart: true,
      alt:'Work',
      content:'work'
    },
    {
      ServicesH2: "Skills",
      Icon: require("../../images/skills.svg").default,
      ServicesP: "view",
      ServicesP2: ``,
      imgStart:false,
      alt:'Skills',
      content:'skills'
    },
    {
      ServicesH2: "Certificates",
      Icon: require("../../images/certificates.svg").default,
      ServicesP: "view",
      ServicesP2: ``,
      imgStart:false,
      alt:'Certificates',
      content:'certificates'
    },
  ];
  